import { render } from "./TokenStats.vue?vue&type=template&id=37dd97d1&scoped=true"
import script from "./TokenStats.vue?vue&type=script&setup=true&lang=js"
export * from "./TokenStats.vue?vue&type=script&setup=true&lang=js"

import "./TokenStats.vue?vue&type=style&index=0&id=37dd97d1&scoped=true&lang=css"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37dd97d1"],['__file',"resources/js/components/TokenStats.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "37dd97d1"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('37dd97d1', __exports__)) {
    api.reload('37dd97d1', __exports__)
  }
  
  module.hot.accept("./TokenStats.vue?vue&type=template&id=37dd97d1&scoped=true", () => {
    api.rerender('37dd97d1', render)
  })

}


export default __exports__